module.exports = __webpack_public_path__ + "img/creditcard_fill.fbfdfd29.svg";